<template>
  <b-dropdown
    id="transition-status"
    toggle-tag="div"
    toggle-class="p-0 bg-transparent"
    :disabled="disabled"
  >
    <template #button-content>
      <McButton
        variant="secondary"
        text="Ubah Status"
        :icon="'icon-outline_chevron-down'"
        icon-position="right"
        class="me-2"
        :disabled="disabled"
      />
    </template>
    <b-dropdown-item @click="handleShowModal('ACTIVE')">Aktif</b-dropdown-item>
    <b-dropdown-item @click="handleShowModal('INACTIVE')">Non Aktif</b-dropdown-item>

    <b-modal ref="mc-modal" size="md" centered scrollable title="Ubah Status">
      <div class="card-body p-2">
        <p>
          <span>Apakah Anda yakin ingin mengubah status </span>
          <strong>{{ selectedIdsLength }}</strong>
          <span> data berikut?</span>
        </p>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton @click="cancel()" variant="secondary" class="me-2" text="Tidak" />
          <McButton @click="handleTransition" variant="primary" text="Ya" />
        </div>
      </template>
    </b-modal>
  </b-dropdown>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedIdsLength: {
      type: Number,
      required: true,
    },
  },
  emits: ['transition'],
  data() {
    return {
      newStatus: null,
    }
  },
  methods: {
    handleShowModal(status) {
      this.$refs['mc-modal'].show()
      this.newStatus = status
    },
    handleTransition() {
      this.$emit('transition', this.newStatus)
      this.$refs['mc-modal'].hide()
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(#transition-status) {
  .dropdown-toggle {
    border: none;
  }
}
</style>
